
export default {

    install: function(Vue, opts) {

        /**
         * Triggers the global alerter component (in Main.vue)
         * @param  {Object|string} message      e.g. 'Hello world' or { title: 'Hello', message: 'World' }
         * @param  {Arra} actions     e.g. [ { name: 'cancel' }, { name: 'ok', action: () => { alert('hi') }}]
         */
        Vue.prototype.$alert = function(message, actions) {

            const alerter = this.$root.$children[0].$refs.alerter
            if ( !alerter ) {
                console.error('Can\'t find alerter')
            }

            const obj = message !== null && typeof message === 'object' ? message : { message: message }
            alerter.ask(obj.title, obj.message, actions)
        }

    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/vue-alerter.js